<template>
    <svg width="33" height="26" viewBox="0 0 33 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect class="navbar_hoverEffect_second" x="5" y="5" width="23" height="20" rx="4" stroke-width="2"/>
        <path class="navbar_hoverEffect_second" d="M28 9H30C31.1046 9 32 9.89543 32 11V16C32 17.1046 31.1046 18 30 18H28V9Z" stroke-width="2"/>
        <path class="navbar_hoverEffect_second" d="M5 18L3 18C1.89543 18 1 17.1046 1 16L1 11C1 9.89543 1.89543 9 3 9L5 9L5 18Z" stroke-width="2"/>
        <rect class="navbar_hoverEffect" x="19" y="10" width="5" height="5" rx="2.5" stroke-width="2"/>
        <rect class="navbar_hoverEffect"  x="9" y="10" width="5" height="5" rx="2.5" stroke-width="2"/>
        <rect class="navbar_hoverEffect_second" x="10.5" y="0.5" width="4" height="1" rx="0.5" transform="rotate(90 10.5 0.5)" stroke-linejoin="round"/>
        <rect class="navbar_hoverEffect_second" x="20.5" y="20.5" width="8" height="1" rx="0.5" transform="rotate(-180 20.5 20.5)" stroke-linejoin="round"/>
        <rect class="navbar_hoverEffect_second" x="23.5" y="0.5" width="4" height="1" rx="0.5" transform="rotate(90 23.5 0.5)" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
  name: 'ManipulatorsIcon'
}
</script>

<style scoped>
path {
    stroke: var(--nav-menu-new-icon);
}
circle {
    stroke: var(--nav-menu-new-icon);
}
rect {
    stroke: var(--nav-menu-new-icon);
}
</style>
